import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCdcType = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.16667 31.5003C8.16667 25.7837 12.2733 21.0703 17.6867 20.0437L14.21 23.5437L17.5 26.8337L26.8333 17.477L17.5 8.16699L14.21 11.457L17.8967 15.1437V15.2837C9.8 16.2403 3.5 23.147 3.5 31.5003C3.5 40.5303 10.8033 47.8337 19.8333 47.8337H26.8333V43.167H19.8333C13.3933 43.167 8.16667 37.9403 8.16667 31.5003Z",
			fill: "#0D0099"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5 31.5003V47.8337H52.5V31.5003H31.5ZM47.8333 43.167H36.1667V36.167H47.8333V43.167Z",
			fill: "#0D0099"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.5 10.5003H31.5V26.8337H52.5V10.5003Z",
			fill: "#0D0099"
		})
	]
});
export default SvgCdcType;
